module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/CC-47dfbb7e653f9cd59a65dc6ed82213d0.png";